import { useQuery, QueryResult } from '@apollo/client'
import { EESZT_FEED } from '../../../operations/eesztOperations'
import { EesztFeed } from '../../../models/graphqlTypes'

export const useEesztFeed = (): QueryResult<EesztFeed> => {
  return useQuery<EesztFeed>(EESZT_FEED)
}
